import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import duration from 'dayjs/plugin/duration';

dayjs.extend(relativeTime);
dayjs.extend(duration);

const formatTimeSince = (date) => {
  const formattedDate = dayjs.duration(dayjs().diff(date));

  const years = formattedDate.years();
  const months = formattedDate.months();
  const days = formattedDate.days();
  const hours = formattedDate.hours();
  const minutes = formattedDate.minutes();

  const units = [
    { value: years, singular: 'year', plural: 'years' },
    { value: months, singular: 'month', plural: 'months' },
    { value: days, singular: 'day', plural: 'days' },
    { value: hours, singular: 'hour', plural: 'hours' },
    { value: minutes, singular: 'minute', plural: 'minutes' },
  ];

  // Filter out minutes if months are being displayed
  let filteredUnits = months > 0 || days > 0 ? units.filter((unit) => unit.singular !== 'minute') : units;
  filteredUnits = months > 0 ? filteredUnits.filter((unit) => unit.singular !== 'hour') : filteredUnits;

  const formattedUnits = filteredUnits
    .filter((unit) => unit.value > 0)
    .map((unit) => `${unit.value} ${unit.value === 1 ? unit.singular : unit.plural}`)
    .join(', ');

  return formattedUnits;
};

export default formatTimeSince;
